export enum UploadBasketItemErrorType {
  INVALID_QUANTITY = 'INVALID_QUANTITY',
  INVALID_DATE = 'INVALID_DATE',
  INVALID_WEEK = 'INVALID_WEEK',
  INVALID_ADDRESS = 'INVALID_ADDRESS',
  INVALID_PRODUCTS = 'INVALID_PRODUCTS',
  INVALID_ORDER_TYPE = 'INVALID_ORDER_TYPE',
}

export type BasketMDOUploadErrors = {
  [key in UploadBasketItemErrorType]: number[];
};
